module.exports = __webpack_public_path__ + "static/media/cow.3046edc4.svg";